// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c0d893a6","186":"dae26351","344":"0f56ef4d","372":"66bb4cce","738":"3092a59c","841":"b41f212d","851":"74d57b84","856":"fe474afb"}[chunkId] + ".chunk.js";
};